import { render } from "react-dom";
import { jsonParse } from "../../../../wp-utils/v1";
import Viewer from "./Components/Viewer";

import "./../../public/style.scss";

const FrontEnd = ({ attributes }) => {
  function __(text, textdomain = "") {
    return text;
  }
  return <Viewer attributes={attributes} __={__} />;
};

export default FrontEnd;

document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".modelViewerBlock");

  blocks.forEach((dom) => {
    const dataset = { ...dom.dataset } || {};
    setTimeout(() => {
      Object.keys(dom.dataset).map((key) => delete dom.dataset[key]);
    }, 10);

    const attributes = jsonParse(dataset.attributes);
    const selector = dataset.selector;
    if (selector && document.querySelector(selector)) {
      const classes = dom.getAttribute("class");
      dom = document.querySelector(selector);

      dom.setAttribute("style", `width:${dom.offsetWidth}px !important;height:350px`);
      window.dom = dom;
    }
    // console.log({ selector, dom });
    render(<FrontEnd attributes={attributes} />, dom);
  });
});
